import React from 'react';
import {useI18n} from '../../../../../data/hooks/i18nHooks';
import {useMyAccount, useMyUserId} from '../../../../../data/hooks/sessionHooks';
import ConnectionBetweenUsersHeader from '../../../../elements/ConnectionBetweenUsersHeader/ConnectionBetweenUsersHeader';
import TopBar from '../../../../elements/TopBar/TopBar';
import TopBarEvent from '../../../../elements/TopBar/TopBarEvent';
import ChatIcon from '../../../../elements/TopBar/inner/ChatIcon';
import UserName from '../../../../elements/UserName/UserName';
import TopBarFavoriteParticipant from '../../TopBarFavoriteParticipant';
import UserProfileTabs from '../common/UserProfileTabs';

function UserProfileConnectionHeader(props) {
    const {event, user, returnURL, canBeInvited = false, inviteURL, onPokeUser} = props,
        headerIcons = [<TopBarFavoriteParticipant event={event} user={user} key="favorite" />, !event ? <ChatIcon key="chat" /> : null],
        i18n = useI18n(),
        myUserId = useMyUserId(),
        myAccount = useMyAccount(),
        isMe = user.user_id == myUserId;

    return (
        <div>
            {event ? (
                <TopBarEvent event={event} returnURL={returnURL} icons={headerIcons}>
                    {i18n['label.contact.information']}
                </TopBarEvent>
            ) : (
                <TopBar returnURL=".." icons={headerIcons}>
                    {i18n['label.contact.information']}
                </TopBar>
            )}
            <hr />
            <div className="marginTop marginBottom">
                <ConnectionBetweenUsersHeader left={{user: isMe ? null : myAccount}} right={{user}} />
                <div
                    className="marginTop"
                    style={{
                        width: 280,
                        paddingLeft: 140,
                        margin: '8px auto',
                        textAlign: 'center',
                    }}>
                    <div className="text name">
                        <UserName user={user} />
                    </div>
                    <div className="text position">{user.position}</div>
                    <div className="text company">{user.company}</div>
                    <br />
                </div>
            </div>
            <UserProfileTabs event={event} user={user} isMe={isMe} canBeInvited={canBeInvited} inviteURL={inviteURL} onPokeUser={onPokeUser} />
        </div>
    );
}

export default UserProfileConnectionHeader;
